import React, { useEffect, useState } from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import useAutosave from "src/hooks/useAutosave";
import { useLoading } from "src/hooks/useLoading";
import { IRootState } from "src/store/reducers";
import { appBuilderShouldSave } from "src/store/reducers/applicationBuilder";
import { fetchProductDetails, saveProductDetails } from "src/store/reducers/applicationProduct";
import { mapKeyToValue, mapValueToKey } from "src/util/util.mapDropdownOptions";
import { TabProps } from "../../pages";
import ApplicantInformationForm from "./ApplicantInformation/ApplicantInformation";
import IndividualInforceForm from "./IndividualInforce/IndividualInforce";
import ProductPolicyForm from "./ProductPolicy/ProductPolicy";
import RidersForm from "./Riders/Riders";

export const AppProductDetail = (props: TabProps) => {
  const { id: applicationID } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const [formRef, setFormRef] = useState(null);
  const { setIsLoading } = useLoading();

  const { productDetails, app } = useSelector((state: IRootState) => ({
    productDetails: state.applicationProduct.productDetails,
    app: state.applications.map[applicationID],
  }));

  useEffect(() => {
    setIsLoading(true);
    dispatch(fetchProductDetails(applicationID));
    setIsLoading(false);
  }, [dispatch, applicationID]);

  const performSave = async () => {
    dispatch(appBuilderShouldSave(false));

    if (!formRef) return;
    const state = formRef.getState();
    const values = state.values;

    const payload = {
      ...values,
      applicationID,
      eliminationPeriodTypeID: mapValueToKey(
        values.eliminationPeriodTypeID,
        productDetails.selectEliminationPeriodTypeList,
      ),
      benefitPeriodTypeID: mapValueToKey(values.benefitPeriodTypeID, productDetails.selectBenefitPeriodTypeList),
    };

    try {
      await dispatch(saveProductDetails(applicationID, payload));
      await dispatch(fetchProductDetails(applicationID));
    } catch (error) {}
  };

  const AutoSave = useAutosave(props, performSave);

  return (
    <Form
      destroyOnUnregister={true}
      validate={props.validate}
      initialValues={{
        ...productDetails,
        eliminationPeriodTypeID: mapKeyToValue(
          productDetails?.eliminationPeriodTypeID,
          productDetails?.selectEliminationPeriodTypeList,
        ),
        benefitPeriodTypeID: mapKeyToValue(
          productDetails?.benefitPeriodTypeID,
          productDetails?.selectBenefitPeriodTypeList,
        ),
        entryDate: app?.entryDate,
        signedDate: app?.signedDate,
      }}
      onSubmit={performSave}>
      {({ form, dirty }) => {
        if (!formRef) {
          setFormRef(form);
        }

        useEffect(() => {
          props.onDirty(dirty);
        }, [dirty]);

        return (
          <form onSubmit={form.submit}>
            <div className="product-detail__container">
              <ProductPolicyForm productDetails={productDetails} />
              <RidersForm productDetails={productDetails} />
              <IndividualInforceForm productDetails={productDetails} />
              <ApplicantInformationForm />
            </div>
            <AutoSave />
          </form>
        );
      }}
    </Form>
  );
};
